<template>
    <div class="traders-board container">
        <div class="row">
            <div class="col text-end">
                <h3 class="float-start">Your Traders:</h3>

                <div class="dropdown">
                    <button class="btn btn-sm btn-link dropdown-toggle" type="button" id="traders-filter" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false"><i class="fa-solid fa-sliders"></i> filter {{ totalTraders }}</button>
                    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="traders-filter">
                        <li class="dropdown-header">Show only:</li>
                        <li class="mb-1">
                            <a @click.prevent="showOnly('common')" class="dropdown-item" href="#">
                                <i v-if="show.common" class="fa-solid fa-circle-check text-primary"></i>
                                <i v-else class="fa-regular fa-circle text-primary"></i>
                                <h5 class="rarity-container d-inline"><span class="rarity badge common">common</span></h5>
                                <i v-if="rarity === 'common'" class="fa-solid fa-angles-left text-primary opacity-50"></i>
                            </a>
                        </li>
                        <li class="mb-1">
                            <a @click.prevent="showOnly('uncommon')" class="dropdown-item" href="#">
                                <i v-if="show.uncommon" class="fa-solid fa-circle-check text-primary"></i>
                                <i v-else class="fa-regular fa-circle text-primary"></i>
                                <h5 class="rarity-container d-inline"><span class="rarity badge uncommon">uncommon</span></h5>
                                <i v-if="rarity === 'uncommon'" class="fa-solid fa-angles-left text-primary opacity-50"></i>
                            </a>
                        </li>
                        <li class="mb-1">
                            <a @click.prevent="showOnly('rare')" class="dropdown-item" href="#">
                                <i v-if="show.rare" class="fa-solid fa-circle-check text-primary"></i>
                                <i v-else class="fa-regular fa-circle text-primary"></i>
                                <h5 class="rarity-container d-inline"><span class="rarity badge rare">rare</span></h5>
                                <i v-if="rarity === 'rare'" class="fa-solid fa-angles-left text-primary opacity-50"></i>
                            </a>
                        </li>
                        <li class="mb-1">
                            <a @click.prevent="showOnly('epic')" class="dropdown-item" href="#">
                                <i v-if="show.epic" class="fa-solid fa-circle-check text-primary"></i>
                                <i v-else class="fa-regular fa-circle text-primary"></i>
                                <h5 class="rarity-container d-inline"><span class="rarity badge epic">epic</span></h5>
                                <i v-if="rarity === 'epic'" class="fa-solid fa-angles-left text-primary opacity-50"></i>
                            </a>
                        </li>
                        <li class="mb-1">
                            <a @click.prevent="showOnly('legendary')" class="dropdown-item" href="#">
                                <i v-if="show.legendary" class="fa-solid fa-circle-check text-primary"></i>
                                <i v-else class="fa-regular fa-circle text-primary"></i>
                                <h5 class="rarity-container d-inline"><span class="rarity badge legendary">legendary</span></h5>
                                <i v-if="rarity === 'legendary'" class="fa-solid fa-angles-left text-primary opacity-50"></i>
                            </a>
                        </li>
                        <li class="mb-1">
                            <a @click.prevent="showOnly('mythic')" class="dropdown-item" href="#">
                                <i v-if="show.mythic" class="fa-solid fa-circle-check text-primary"></i>
                                <i v-else class="fa-regular fa-circle text-primary"></i>
                                <h5 class="rarity-container d-inline"><span class="rarity badge mythic">mythic</span></h5>
                                <i v-if="rarity === 'mythic'" class="fa-solid fa-angles-left text-primary opacity-50"></i>
                            </a>
                        </li>

                        <button @click="showAll" type="button" class="btn btn-sm btn-link m-auto">show all</button>
                    </ul>
                </div>

<!--                <div class="dropdown">-->
<!--                    <button class="btn btn-sm btn-link dropdown-toggle" type="button" id="traders-filter" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa-solid fa-sliders"></i> filter {{ totalTraders }}</button>-->
<!--                    <div class="dropdown-menu dropdown-menu-end" aria-labelledby="traders-filter">-->
<!--                        <div class="dropdown-header">Limit Traders By:</div>-->
<!--                        <form class="px-4 py-3">-->
<!--                            <div class="mb-3">-->
<!--                                <div class="form-check">-->
<!--                                    <input type="checkbox" class="form-check-input" id="oe" v-model="show.oe">-->
<!--                                    <label class="form-check-label" for="oe">Open Edition (OE)</label>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="mb-3">-->
<!--                                <div class="form-check">-->
<!--                                    <input type="checkbox" class="form-check-input" id="lr" v-model="show.lr">-->
<!--                                    <label class="form-check-label" for="lr">Limited Release (LR)</label>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="mb-3">-->
<!--                                <div class="form-check">-->
<!--                                    <input type="checkbox" class="form-check-input" id="le" v-model="show.le">-->
<!--                                    <label class="form-check-label" for="le">Limited Edition (LE)</label>-->
<!--                                </div>-->
<!--                            </div>-->

<!--                            <button @click="showAll" type="button" class="btn btn-sm btn-link m-auto">show all</button>-->
<!--                        </form>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
<!--        <div class="row">-->
<!--            <div class="col">-->
<!--                <button @click="clearAll" class="btn btn-sm btn-link text-secondary">Clear All</button>-->
<!--            </div>-->
<!--        </div>-->

        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link" :class="{ active: grailTraders.length || matchedTraders.length }" id="pills-grails-isos-tab" data-bs-toggle="pill" data-bs-target="#pills-grails-isos" type="button" role="tab" aria-controls="pills-grails-isos" aria-selected="true">ISOs</button>
            </li>
            <li v-if="user !== 0" class="nav-item" role="presentation">
                <button class="nav-link" :class="{ active: !grailTraders.length && !matchedTraders.length && tagTraders.length }" id="pills-tags-tab" data-bs-toggle="pill" data-bs-target="#pills-tags" type="button" role="tab" aria-controls="pills-tags" aria-selected="false">Interests</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" :class="{ active: !grailTraders.length && !matchedTraders.length && !tagTraders.length }" id="pills-unmatched-tab" data-bs-toggle="pill" data-bs-target="#pills-unmatched" type="button" role="tab" aria-controls="pills-unmatched" aria-selected="false">Others</button>
            </li>
            <li v-if="user !== 0" class="nav-item" role="presentation">
                <button class="nav-link" id="pills-unwanted-tab" data-bs-toggle="pill" data-bs-target="#pills-unwanted" type="button" role="tab" aria-controls="pills-unwanted" aria-selected="false">Owned</button>
            </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade" :class="[grailTraders.length || matchedTraders.length ? 'show active' : '']" id="pills-grails-isos" role="tabpanel" aria-labelledby="pills-grails-isos-tab">
                <div v-if="grailTraders.length" class="row trader-row grail-match-row">
                    <div class="col-12"><h4 class="text-dark"><i class="fa-regular fa-crown"></i>  You have pins on this trader's Grail list...</h4></div>
                    <TradersBoardItem @toggle="toggleTradersBoardItem" v-for="trader in filteredGrailTraders" :key="trader.id" :id="trader.id" :title="trader.title" :pin="trader.pin_id" :name="trader.name" :series="trader.series" :selected="trader.selected" :thumb="trader.image_pinail" :rarity="trader.rarity" :is-listed="trader.is_listed" class="col-xl-2 col-lg-3 col-md-4 col-6 grail-match"></TradersBoardItem>
                </div>
                <div v-if="matchedTraders.length" class="row trader-row iso-match-row">
                    <div class="col-12"><h4 class="text-dark"><i class="fa-regular fa-magnifying-glass-plus"></i>  
                        <span v-if="listed">You have pins this trader is searching for...</span>
                        <span v-else>You have pins other traders are searching for...</span>
                    </h4></div>
                    <template v-if="listed">
                        <div v-if="filteredMatchedTraders.length" class="col-12 mt-2">
                            <!-- <button @click="toggleIsos" class="btn btn-sm btn-link text-trader">Toggle All ({{ filteredMatchedTraders.length }})</button> -->
                        </div>
                        <div v-else>But they are hidden by your filter (<a @click.prevent="showAll" href="#">reset</a>)</div>
                    </template>
                    <TradersBoardItem @toggle="toggleTradersBoardItem" v-for="trader in filteredMatchedTraders" :key="trader.id" :id="trader.id" :title="trader.title" :pin="trader.pin_id" :name="trader.name" :series="trader.series" :selected="trader.selected" :thumb="trader.image_pinail" :rarity="trader.rarity" :is-listed="trader.is_listed" class="col-xl-2 col-lg-3 col-md-4 col-6 iso-match"></TradersBoardItem>
                    <!-- <TradersBoardItem @toggle="toggleTradersBoardItem" v-for="trader in filteredMatchedTraders.sort((a, b) => b.sort - a.sort)" :key="trader.id" :id="trader.id" :title="trader.title" :pin="trader.pin_id" :name="trader.name" :series="trader.series" :selected="trader.selected" :thumb="trader.image_pinail" :rarity="trader.rarity" :is-listed="trader.is_listed" class="col-xl-2 col-lg-3 col-md-4 col-6 iso-match"></TradersBoardItem> -->
                </div>
                <div v-if="!grailTraders.length && !matchedTraders.length" class="row trader-row">
                    <div class="col-12">
                        <h4 class="text-dark">You have no pins that are In Search Of (ISO) for this trader.</h4>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" :class="[!grailTraders.length && !matchedTraders.length && user !== 0 ? 'show active' : '']" id="pills-tags" role="tabpanel" aria-labelledby="pills-tags-tab">
                <div v-if="filteredTagTraders.length" class="row trader-row">
                    <div class="col-12"><h5 class="text-dark"><i class="fa-regular fa-circle-check"></i>  You have pins matching this trader's interests...</h5></div>
                    <TradersBoardItem @toggle="toggleTradersBoardItem" v-for="trader in filteredTagTraders" :key="trader.id" :id="trader.id" :title="trader.title" :pin="trader.pin_id" :name="trader.name" :series="trader.series" :selected="trader.selected" :thumb="trader.image_pinail" :rarity="trader.rarity" :is-listed="trader.is_listed" class="col-xl-2 col-lg-3 col-md-4 col-6"></TradersBoardItem>
                </div>
                <div v-if="!filteredTagTraders.length" class="row trader-row">
                    <div class="col-12">
                        <h4 class="text-dark">You have no pins matching this trader's interests.</h4>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" :class="[!grailTraders.length && !matchedTraders.length && !tagTraders.length ? 'show active' : '']" id="pills-unmatched" role="tabpanel" aria-labelledby="pills-unmatched-tab">
                <div class="row trader-row">
                    <div v-if="filteredUnmatchedTraders.length && limit < 0" class="col-12 mt-2">
                    </div>
                    <div v-else-if="limit > -1" class="col-12 mt-2">
                        <strong>{{ limit }} left</strong>
                    </div>
                    <TradersBoardItem @toggle="toggleTradersBoardItem" v-for="trader in filteredUnmatchedTraders" :key="trader.id" :id="trader.id" :title="trader.title" :pin="trader.pin_id" :name="trader.name" :series="trader.series" :selected="trader.selected" :thumb="trader.image_pinail" :rarity="trader.rarity" :is-listed="trader.is_listed" class="col-xl-2 col-lg-3 col-md-4 col-6"></TradersBoardItem>
                </div>
            </div>
            <div class="tab-pane fade" id="pills-unwanted" role="tabpanel" aria-labelledby="pills-unwanted-tab">
                <div v-if="filteredOwnedTraders.length" class="row trader-row own-match-row">
                    <div class="col-12"><h5 class="text-light"><i class="fa-regular fa-circle-check"></i>  Trader already owns these...</h5></div>
                    <TradersBoardItem @toggle="toggleTradersBoardItem" v-for="trader in filteredOwnedTraders" :key="trader.id" :id="trader.id" :title="trader.title" :pin="trader.pin_id" :name="trader.name" :series="trader.series" :selected="trader.selected" :thumb="trader.image_pinail" :rarity="trader.rarity" :is-listed="trader.is_listed" class="col-xl-2 col-lg-3 col-md-4 col-6"></TradersBoardItem>
                </div>
                <div v-if="declinedTraders.length" class="row trader-row declined-match-row">
                    <div class="col-12"><h5><i class="fa-solid fa-ban"></i>  Trader already declined these...</h5></div>
                    <div v-for="trader in filteredDeclinedTraders" :key="trader.id" class="traders-board-item col-xl-2 col-lg-3 col-md-4 col-6">
                        <div class="card" data-bs-toggle="tooltip" data-bs-placement="top" :title="trader.title">
                            <picture>
                                <source :srcset="'https://pinandpop.s3.amazonaws.com/images/pinails/' + trader.image_pinail + '.webp'" type="image/webp">
                                <source :srcset="'https://pinandpop.s3.amazonaws.com/images/pinails/' + trader.image_pinail + '.jpg'" type="image/jpeg">
                                <img class="card-img-top border" :src="'https://pinandpop.s3.amazonaws.com/images/pinails/' + trader.image_pinail + '.jpg'" :alt="trader.title">
                            </picture>
                        </div>
                    </div>
                </div>
                <div v-if="!filteredOwnedTraders.length && !declinedTraders.length" class="row trader-row">
                    <div class="col-12">
                        <h4 class="text-dark">You have no pins that are already owned or have been declined by this trader.</h4>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import TradersBoardItem from "./TradersBoardItem.vue";
// import {gsap} from "gsap";

export default {
    name: 'TradersBoard',
    props: {
        listed: {
            type: Number,
            required: false
        },
        rarity: {
            type: String,
            required: false
        },
        user: {
            type: Number,
            required: true
        },
        traders: {
            type: Array,
            required: true
        },
        matches: {
            type: Object,
            required: false
        },
        limit: {
            type: Number,
            default: -1
        }
    },
    components: {
        TradersBoardItem
    },
    data: function() {
        return {
            matchedTraders: [],
            grailTraders: [],
            tagTraders: [],
            ownedTraders: [],
            declinedTraders: [],
            unmatchedTraders: this.traders,
            show: {
                common: true,
                uncommon: true,
                rare: true,
                epic: true,
                legendary: true,
                mythic: true,
                unknown: true
            }
            // show: {
            //     oe: true,
            //     lr: true,
            //     le: true
            // }
        }
    },
    computed: {
        totalTraders: function() {
            return this.filteredGrailTraders.length + this.filteredMatchedTraders.length + this.filteredTagTraders.length + this.filteredUnmatchedTraders.length + this.filteredOwnedTraders.length;
        },
        filteredGrailTraders: function() {
            return this.grailTraders.filter(t => this.show[t.rarity ? t.rarity : 'common']);
        },
        filteredMatchedTraders: function() {
            return this.matchedTraders.filter(t => this.show[t.rarity ? t.rarity : 'common']);
        },
        filteredTagTraders: function() {
            return this.tagTraders.filter(t => this.show[t.rarity ? t.rarity : 'common']);
        },
        filteredUnmatchedTraders: function() {
            return this.unmatchedTraders.filter(t => this.show[t.rarity ? t.rarity : 'common']);
        },
        filteredOwnedTraders: function() {
            return this.ownedTraders.filter(t => this.show[t.rarity ? t.rarity : 'common']);
        },
        filteredDeclinedTraders: function() {
            return this.declinedTraders.filter(t => this.show[t.rarity ? t.rarity : 'common']);
        }
    },
    methods: {
        toggleIsos() {
            if (this.filteredMatchedTraders) {
                let toggle = !this.filteredMatchedTraders[0].selected;
                this.filteredMatchedTraders.forEach(t => this.$emit('toggle', t.id, toggle));
            }
        },

        // toggleUnmatched() {
        //     if (this.filteredUnmatchedTraders) {
        //         let toggle = !this.filteredUnmatchedTraders[0].selected;
        //         this.filteredUnmatchedTraders.forEach(t => this.$emit('toggle', t.id, toggle));
        //     }
        // },

        clearAll() {
            this.traders.forEach((trader) => {
                // VueEvent.$emit('toggleTraderPin', trader.id, false);
                this.$emit('toggle', trader.id, false);
            });
        },

        showOnly(showRarity) {
            if (this.show.common && this.show.uncommon && this.show.rare && this.show.epic && this.show.legendary && this.show.mythic) {
                this.show.common = showRarity === 'common';
                this.show.uncommon = showRarity === 'uncommon';
                this.show.rare = showRarity === 'rare';
                this.show.epic = showRarity === 'epic';
                this.show.legendary = showRarity === 'legendary';
                this.show.mythic = showRarity === 'mythic';
            } else {
                this.show[showRarity] = !this.show[showRarity];
            }
        },

        showAll() {
            // this.show.oe = true;
            // this.show.lr = true;
            // this.show.le = true;
            this.show.common = true;
            this.show.uncommon = true;
            this.show.rare = true;
            this.show.epic = true;
            this.show.legendary = true;
            this.show.mythic = true;
            this.show.unknown = true;
        },

        updateTraders() {
            if (this.matches) {
                let declined = this.matches.declined.filter(item => item.user_id === this.user && item.listing_id === this.listed);
                let isos = this.matches.isos.filter(item => item.user_id === this.user && !declined.map(item => item.pin_id).includes(item.pin_id));
                let grails = this.matches.grails.filter(item => item.user_id === this.user);
                let owns = this.matches.owns.filter(item => item.user_id === this.user && !declined.map(item => item.pin_id).includes(item.pin_id));
                let tags = this.matches.tags.filter(
                    item => item.user_id === this.user
                    && !declined.map(item => item.pin_id).includes(item.pin_id)
                    && !isos.map(item => item.pin_id).includes(item.pin_id)
                    && !grails.map(item => item.pin_id).includes(item.pin_id)
                    && !owns.map(item => item.pin_id).includes(item.pin_id)
                );
                

                this.matchedTraders = this.traders.filter(item => isos.map(item => item.pin_id).includes(item.pin_id));
                this.grailTraders = this.traders.filter(item => grails.map(item => item.pin_id).includes(item.pin_id));
                this.tagTraders = this.traders.filter(item => tags.map(item => item.pin_id).includes(item.pin_id));
                this.ownedTraders = this.traders.filter(item => owns.map(item => item.pin_id).includes(item.pin_id));
                this.declinedTraders = this.traders.filter(item => declined.map(item => item.pin_id).includes(item.pin_id));

                let matches = [
                    ...new Set(this.matchedTraders.map(o => o.id)),
                    ...new Set(this.grailTraders.map(o => o.id)),
                    ...new Set(this.tagTraders.map(o => o.id)),
                    ...new Set(this.ownedTraders.map(o => o.id)),
                    ...new Set(this.declinedTraders.map(o => o.id))
                ];

                this.unmatchedTraders = this.traders.filter(item => !matches.includes(item.id));
            } else {
                this.matchedTraders = this.traders.filter(item => item.is_iso);
                let matches = [
                    ...new Set(this.matchedTraders.map(o => o.id))
                ];
                // this.unmatchedTraders = this.traders;
                this.unmatchedTraders = this.traders.filter(item => !matches.includes(item.id));
            }
        },

        toggleTradersBoardItem(traderId) {
            // if (this.limit === false || this.limit > 0) {
                this.$emit('toggle', traderId);
            // }
        }
    },
    mounted() {
        this.updateTraders();
    },
    watch: {
        traders: function(newValue) {
            this.updateTraders();
        },

        show: {
            handler(newValue) {
                this.show.unknown = (newValue.common && newValue.uncommon && newValue.rare && newValue.epic && newValue.legendary && newValue.mythic);
            },
            deep: true
        }
    }
}
</script>
